import React, { useState, useEffect, useCallback } from "react";
import { Trophy, X, MessageCircle } from "lucide-react";
import { winners, contact } from "../mock";

const WinningPopup = () => {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const showNext = useCallback(() => {
    setIndex((prev) => (prev + 1) % winners.length);
    setVisible(true);
    // hide after a few seconds
    const hideTimer = setTimeout(() => setVisible(false), 5000);
    return () => clearTimeout(hideTimer);
  }, []);

  useEffect(() => {
    if (dismissed) return;
    // initial delay before first popup
    const startTimer = setTimeout(() => showNext(), 3000);
    return () => clearTimeout(startTimer);
  }, [dismissed, showNext]);

  useEffect(() => {
    if (dismissed) return;
    // cycle every 8s
    const interval = setInterval(() => {
      showNext();
    }, 8000);
    return () => clearInterval(interval);
  }, [dismissed, showNext]);

  if (dismissed) return null;

  const w = winners[index];

  return (
    <div
      className={`fixed right-4 bottom-24 z-40 transition-all duration-500 ${
        visible ? "translate-x-0 opacity-100" : "translate-x-[130%] opacity-0"
      }`}
    >
      <a
        href={contact.whatsapp}
        target="_blank"
        rel="noreferrer"
        className="group relative flex items-center gap-3 w-[290px] rounded-xl border border-[#00ff87]/40 bg-[#0c0d17]/95 backdrop-blur-md p-3 pr-4 shadow-[0_0_24px_rgba(0,255,135,0.18)] hover:border-[#00ff87] transition-colors"
      >
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setDismissed(true);
          }}
          className="absolute -top-2 -left-2 h-6 w-6 grid place-items-center rounded-full bg-[#12131f] border border-white/15 text-gray-400 hover:text-white"
          aria-label="Close"
        >
          <X size={13} />
        </button>

        <div className="h-11 w-11 shrink-0 grid place-items-center rounded-lg bg-gradient-to-br from-[#00ff87]/25 to-[#00e5ff]/25 text-[#00ff87]">
          <Trophy size={22} />
        </div>

        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5">
            <span className="h-2 w-2 rounded-full bg-[#00ff87] animate-pulse" />
            <span className="text-[10px] uppercase tracking-wide text-[#00ff87] font-semibold">
              Live Winner
            </span>
          </div>
          <p className="text-sm text-white leading-tight mt-0.5 truncate">
            <span className="font-semibold">{w.name}</span> won{" "}
            <span className="font-tech font-bold neon-green">₹{w.amount}</span>
          </p>
          <p className="text-[11px] text-gray-400 truncate">
            {w.game} · {w.city}
          </p>
        </div>

        <MessageCircle
          size={18}
          className="shrink-0 text-[#25D366] group-hover:scale-110 transition-transform"
        />
      </a>
    </div>
  );
};

export default WinningPopup;
